import qs from 'qs'
import axios from '@/services/axios'

export default {
  // 获取表格数据
  getTableData(params) {
    const baseURL =
      _.get(Wiz, 'globalSettings.globalConfig.diyApiBase') || localStorage.getItem('DiyApiBase')
    const token = Wiz.AuthHooks.GetToken()
    const headers = {
      Authorization: `Bearer ${localStorage.getItem('authorization') || token}`,
    }
    return axios.post(`${baseURL}/api/FormEngine/GetTableData`, params, { headers })
  },
  // 获取接口引擎
  getApiEngineData(params) {
    const baseURL =
      _.get(Wiz, 'globalSettings.globalConfig.diyApiBase') || localStorage.getItem('DiyApiBase')
    const token = Wiz.AuthHooks.GetToken()
    const headers = {
      Authorization: `Bearer ${localStorage.getItem('authorization') || token}`,
    }
    return axios.post(`${baseURL}/api/ApiEngine/Run`, params, { headers })
  },
}
